<template>
  <div class="taskBox">
    <a-row class="task-search">
      <a-col :span="5">
        <span class="serachName">任务名称 :</span>
        <a-input v-model="form.taskName" placeholder="请输入任务名称" @pressEnter="onSerch" />
      </a-col>
      <a-col :span="15">
        <span class="serachName">创建日期 :</span>
        <a-range-picker
          v-model="form.createTime"
          class="w-224"
          :show-time="true"
          format="YYYY.MM.DD HH:mm"
          @ok="onSerch"
        >
          <template #suffixIcon>
            <a-icon type="calendar" />
          </template>
        </a-range-picker>
        <a-button class="btnStyle" type="primary" @click="getList">查询</a-button>
        <a-button class="btnStyle" @click="onReset">重置</a-button>
      </a-col>
      <a-col :span="4" class="tips">
        <a-icon type="exclamation-circle" theme="filled" />
        下载文件仅保留7天
      </a-col>
    </a-row>
    <div>
      <a-table
        :columns="taskColumnsList"
        :data-source="taskTableList"
        :pagination="pagination"
        row-key="id"
        size="small"
        class="goods-table"
        bordered
        @change="tableChange"
      >
        <template slot="status" slot-scope="text">
          <span :class="text === 'EXECUTING' || text === 'QUEUING' ? '' : text === 'FAILED' ? 'redColor' : 'finish'">{{ taskStatusList[text] }}</span>
        </template>
        <template slot="resultMsg" slot-scope="text, rowData">
          <div v-if="rowData.currentProgress < 100" class="task-progress">
            <a-progress
              :percent="rowData.currentProgress"
              size="small"
              class="progress"
              :stroke-width="2"
              stroke-color="linear-gradient(270deg, #37C598 0%, #6BA9EC 100%)"
            />
            <p>{{text}}</p>
          </div>
          <div v-else>
            <a-tooltip>
              <template #title>
                <span>{{ text }}</span>
              </template>
                <span class="tooltip_text">
                  {{textEdit(text, 0) }}
                  <span :class="textEdit(text, 1) !== '0' ? 'errorStyle' : '' ">{{textEdit(text, 1)}}</span>
                </span>
              </a-tooltip>
          </div>
        </template>
        <template slot="fileLink" slot-scope="text, rowData">
          <span
            v-if="text"
            v-track-click="{ trackName: '下载' }"
            class="downStyle flex align-center"
            @click="downLoad(rowData.fileLink, rowData)"
          >
            <img src="@/assets/img/icon_download.png" alt="">
            点击下载
          </span>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { fetchTaskList } from './api';

const taskStatusList = {
    QUEUING: '排队中',
    EXECUTING: '执行中',
    FINISHED: '已完成',
    FAILED: '执行失败'
}

export default {
  name: "TaskList",
  components: {},
  props: {},
  data() {
    return {
      form: {
        taskName: "",
        createTime: [moment().subtract(7, 'days').startOf('day'), moment().endOf('day')]
      },
      taskStatusList,
      taskColumnsList: [
        {
          title: "任务名称",
          dataIndex: "taskName",
          key: "taskName",
          scopedSlots: { customRender: "taskName" },
          width: 180,
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          key: "createTime",
          scopedSlots: { customRender: "createTime" },
          width: 130,
        },
        {
          title: "创建人",
          dataIndex: "createUserName",
          key: "createUserName",
          scopedSlots: { customRender: "createUserName" },
          width: 70,
        },
        {
          title: "任务状态",
          dataIndex: "status",
          key: "status",
          scopedSlots: { customRender: "status" }, // QUEUING(排队中), EXECUTING(执行中), FINISHED(已完成), FAILED(执行失败)
          width: 70,
        },
        {
          title: "任务结果",
          dataIndex: "resultMsg",
          key: "resultMsg",
          scopedSlots: { customRender: "resultMsg" },
          width: 180,
          ellipsis: true,
        },
        {
          title: "操作",
          dataIndex: "fileLink",
          key: "fileLink",
          scopedSlots: { customRender: "fileLink" },
          width: 130,
        },
      ],
      taskTableList: [],
      pageSize: 10,
      pagination: {
        current: 1,
        total: 0,
        defaultPageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        onShowSizeChange: (current, pageSize) => {(this.pageSize = pageSize)},
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      },
      timer: null,
      allFinish: true,
    };
  },
  computed: {},
  created() {
    this.getList()
    // this.timer = setInterval(this.getList, 30000)
  },
  mounted() {},
  beforeDestroy(){
    // clearInterval(this.timer)
  },
  methods: {
    textEdit(value, index){
      if(!value || !value.includes(':')){
        if (index === 0) {
          return value;
        }
         return '';
      }
      const text = value.split(':');
      if (text.length > 2) {
        if (index === 0) {
          return `${text[0]}${text[1]}${text[2]}`;
        }
        return text[3];
      }
      if (index === 0) {
        return text[0];
      }
      return text[1];
    },
    getList(){
        const time = this.form.createTime
        const data = {
            taskName: this.form.taskName === "" ? null : this.form.taskName,
            startCreateTime: time.length > 0 ? Number(time[0]?.format('x')) : null,
            endCreateTime: time.length > 0 ? Number(time[1]?.format('x')) : null
        }

        const params = {
            size: this.pageSize,
            page: this.pagination.current
        }
        fetchTaskList(data, params).then((res) => {
            this.pagination.total = res.total
            this.taskTableList = res.records
            let allFinish = true
            this.taskTableList.forEach((e, i) => {
              if (e.currentProgress < 100) {
                allFinish = false
              }
              e.key = i
              e.createTime = moment(e.createTime).format('YYYY-MM-DD HH:mm:ss')
            })
            this.allFinish = allFinish
            if (!this.allFinish) {
              this.timer = setTimeout(() => {
                this.getList()
              }, 2000);
            } else {
              clearTimeout(this.timer)
            }
        })
    },
    downLoad(link, rowData) {
      if (rowData.fileIsTimeout) {
        this.$message.warning('文件已过期！')
      } else {
        try {
          // eslint-disable-next-line no-underscore-dangle
          if (window.__POWERED_BY_WUJIE__) {
            window.open(link)
          }else {
            window.location.href = link;
          }

        } catch (err) {
            console.error(err);
        }
      }
    },
    onSerch() {
      this.pagination.current = 1
        this.getList()
    },
    onReset() {
        this.form.taskName = ''
        this.form.createTime = [moment().subtract(7, 'days').startOf('day'), moment().endOf('day')]
        this.getList()
    },
    tableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current,
      };
      this.getList()
    },
  },
};
</script>

<style lang="less" scoped>
.task-progress {
  .progress {
    max-width: 272px;
    ::v-deep .ant-progress-text {
      color: #06B880;
    }
  }
  p {
    font-size: 12px;
    color: #606266;
  }
}
.taskBox {
  background: #fff;
  min-height: calc(100vh - 110px);
  padding: 30px;
  box-sizing: border-box;
  margin: 0 24px 30px;
  border-radius: 4px;
  .task-search {
    margin: 15px 0;
  }
  .serachName {
    margin-right: 10px;
  }
  .ant-form-item {
    width: 25%;
    .Reset {
      margin-left: 25px;
    }
    /deep/ .ant-form-item-label {
      text-align: left !important;
    }
  }
  .itemTime {
    width: 30%;
  }
  .tips {
    color:#ED4934;
    text-align: right;
    line-height: 32px;
  }
  .textColor {
    color: #ccc;
  }
  .redColor {
    color: red;
  }
  .finish {
    color: #909399;
  }
  .downStyle {
    color: #06b880;
    img {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
    &:hover {
      cursor: pointer;
    }
  }
  .ant-input {
    width: calc(100% - 100px);
  }
  .btnStyle {
    margin-left: 20px;
  }
}
/deep/ .errorStyle{
  color: red;
}
/deep/ .ant-table-body{
  margin: 0 !important;
  .ant-table-thead{
    background: #fafafa;
  }
}
.tooltip_text{
  width: 100%;
  display: inline-block;
  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //溢出用省略号显示
  white-space: nowrap;  // 默认不换行；
}
</style>
